<div class="invalid-feedback" *ngIf="errorMessage !== null">
  <span [innerHtml]="errorMessage"></span>
</div>